import React from 'react';
import ReactDOM from 'react-dom';
import charChoose from '../shared/CharChoose';

class WordsChoose extends React.Component {
    render() {
        return (
            <div></div>
        );
    }
}

export default charChoose(WordsChoose, 'lc');


// WEBPACK FOOTER //
// ./src/components/sections/words/WordsChoose.js